export const allocation_form = {
  kind_label: "Kind",
  org_label: "Organization",
  part_label: "Part",
  repair_label: "Repair",
  amount_label: "Amount (USD)",
  note_label: "Note",
  note_placeholder: "Optional note",
  kind_part_sale: "Part sale",
  kind_platform_cut: "Platform cut",
  kind_withdrawal: "Withdrawal",
  kind_repair_spend: "Repair spend",
  kind_test: "Test",
  closed_repair_warning:
    "This repair is closed. Linking spend to a closed repair is allowed but unusual.",
};
